export const SEASON_SWITCH_ITEMS = [
    { label: () => `Estate`, value: 'summer' },
    { label: () => `Inverno`, value: 'winter' },
];
export const IntegerFormat = new Intl.NumberFormat('de-CH', {
    maximumFractionDigits: 2,
});
const POIOverlayTypes = ['sightseeing', 'place', 'travelreport', 'details'];
export const isPOIOverlay = (options) => options && POIOverlayTypes.includes(options.type);
export const SWISS_EXTENT = [2485071, 1074261, 2837119, 1299941];
export const SWISS_CENTER = [2660000, 1190000];
export const EXCLUDED_SEARCH_RESULTS = [
    'TLM_SCHIFFFAHRT',
    'TLM_EISENBAHN',
    'TLM_UEBRIGE_BAHN',
    'TLM_STRASSE',
    'TLM_MAUER',
    'TLM_VERBAUUNG',
    'TLM_VERKEHRSBAUTE_LIN',
    'TLM_LEITUNG',
    'TLM_LEITUNG_STROMSTRASSE',
    'TLM_STRASSENROUTE',
    'TLM_HALTESTELLE',
    'TLM_AUS_EINFAHRT',
    'TLM_STRASSENINFO',
    'TLM_STRASSENNAME',
    'TLM_VERSORGUNGSBAUTE_PKT',
    'TLM_SPORTBAUTE_PLY',
    'TLM_GEBAEUDE_FOOTPRINT',
    'TLM_BODENBEDECKUNG',
    'TLM_EINZELBAUM_GEBUESCH',
    'TLM_BLAMOS',
    'TLM_VERKEHRSBAUTE',
    'TLM_NUTZUNGSAREAL',
    'TLM_STAUBAUTE',
    'TLM_SCHUTZGEBIET',
    'TLM_SCHULE',
    'MORPH_KLEINFORM_PKT',
];
export const SCREENS = {
    zero: 0,
    xxs: 360,
    xs: 428,
    sm: 600,
    md: 820,
    mdx: 1024,
    mdxx: 1194,
    lg: 1239,
    xl: 1440,
    xxl: 1681,
    max: 2184,
};
export const SBB_URL_BY_LANG = {
    de: 'https://www.sbb.ch/de/kaufen/pages/fahrplan/fahrplan.xhtml',
    en: 'https://www.sbb.ch/en/buying/pages/fahrplan/fahrplan.xhtml',
    fr: 'https://www.sbb.ch/fr/acheter/pages/fahrplan/fahrplan.xhtml',
    it: 'https://www.sbb.ch/it/acquistare/pages/fahrplan/fahrplan.xhtml',
};
export const infoEmail = {
    de: 'info@schweizmobil.ch',
    en: 'info@switzerlandmobility.ch',
    it: 'info@svizzeramobile.ch',
    fr: 'info@suissemobile.ch',
};
export const CLOSURES_DETOURS_DISCLAIMER_URL = {
    en: '/en/closures-detours',
    de: '/de/sperrungen-umleitungen',
    it: '/it/chiusure-deviazioni',
    fr: '/fr/fermetures-deviations',
};
//# sourceMappingURL=constants.js.map